export const maxLength = (max, message = 'Too long') => (value) =>
    value && value.length > max ? message : undefined;

export const positive = (value) => {
    if (value < 0) {
        return 'Cannot be negative';
    }
    return undefined;
};
